import type { FilterPreset } from '@ipfabric/utils';
import {
  type ApiTableCommandFactory,
  advancedFilterInitialState,
} from 'components/ApiTable/model/ApiTableModel';
import { selectFilterPreset } from 'components/ApiTable/model/commands/selectFilterPreset';

interface UpdateFilterPresetCommand {
  preset: FilterPreset;
}

export const updateFilterPreset: ApiTableCommandFactory<
  UpdateFilterPresetCommand
> = (cmdContext, dispatch) => async (command) => {
  const { advancedFilter } = cmdContext.getState();

  const updatedPreset = await cmdContext.api.request({
    url: `/filters/${command.preset.id}`,
    method: 'PATCH',
    data: {
      filter: advancedFilter.filters,
    },
  });

  cmdContext.updateState((draft) => {
    draft.advancedFilter = advancedFilterInitialState;
  });

  dispatch(selectFilterPreset, { preset: updatedPreset });
};
